module.exports = __webpack_public_path__ + "static/media/program.b3c01446.png";